export type SortConfig = {
  id: string;
  columns: Column[];
  default?: DefaultData;
  canReset?: boolean;
};

export type Column = {
  id: string;
  field: string;
};

export type DefaultData = {
  column: string;
  order: 'asc' | 'desc' | null | undefined;
};

export const orders = {
  asc: 'asc',
  desc: 'desc',
} as const;
